module.exports = __webpack_public_path__ + "img/view-image.0b9a2f9e.svg";